var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-contraception-methods",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n        svg#freepik_stories-contraception-methods:not(.animated) .animable {\r\n            opacity: 0;\r\n        }\r\n\r\n        svg#freepik_stories-contraception-methods.animated #freepik--contraception-methods--inject-69 {\r\n            animation: 1.5s Infinite linear wind;\r\n            animation-delay: 0s;\r\n        }\r\n\r\n        svg#freepik_stories-contraception-methods.animated #freepik--Character--inject-69 {\r\n            animation: 1.5s Infinite linear floating;\r\n            animation-delay: 0s;\r\n        }\r\n\r\n        @keyframes wind {\r\n            0% {\r\n                transform: rotate(0deg);\r\n            }\r\n\r\n            25% {\r\n                transform: rotate(1deg);\r\n            }\r\n\r\n            75% {\r\n                transform: rotate(-1deg);\r\n            }\r\n        }\r\n\r\n        @keyframes floating {\r\n            0% {\r\n                opacity: 1;\r\n                transform: translateY(0px);\r\n            }\r\n\r\n            50% {\r\n                transform: translateY(-10px);\r\n            }\r\n\r\n            100% {\r\n                opacity: 1;\r\n                transform: translateY(0px);\r\n            }\r\n        }\r\n\r\n        .animator-hidden {\r\n            display: none;\r\n        }\r\n    ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-69",
    className: "animable",
    style: {
      transformOrigin: "267.587px 199.665px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.09,319.86c-23.77-29.66-9-85.76,27-119.87,31.44-29.75,65.25-26.63,92.7-65,25.58-35.75,39.05-74,87.62-89.17C351.64,33.9,377.82,53.08,401,75.44c63.42,61.16,49.62,125.45-33.24,191.18C328.16,298,276.15,332.78,229.3,348.13,173.08,366.55,135.55,356.64,106.09,319.86Z",
    style: {
      fill: "#16A085",
      transformOrigin: "267.587px 199.665px"
    },
    id: "elu5uwaqhyxp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpj14b9b9le"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.09,319.86c-23.77-29.66-9-85.76,27-119.87,31.44-29.75,65.25-26.63,92.7-65,25.58-35.75,39.05-74,87.62-89.17C351.64,33.9,377.82,53.08,401,75.44c63.42,61.16,49.62,125.45-33.24,191.18C328.16,298,276.15,332.78,229.3,348.13,173.08,366.55,135.55,356.64,106.09,319.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      transformOrigin: "267.587px 199.665px"
    },
    className: "animable",
    id: "eltf8ksed9cbr"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-69",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "250px 416.24px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-69",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 416.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--contraception-methods--inject-69",
    className: "animable",
    style: {
      transformOrigin: "257.39px 146.97px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elbi5rtunglri"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250.6,
    cy: 52.47,
    r: 20.58,
    style: {
      fill: "#16A085",
      transformOrigin: "250.6px 52.47px",
      transform: "rotate(-2.85deg)"
    },
    className: "animable",
    id: "el22kohm2olfaj"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "253.56 52.01 248.43 54.54 244.1 45.76 245.93 43.01 249.23 43.23 253.56 52.01",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "248.83px 48.775px"
    },
    id: "elyoqcx71gfl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.47,44.6a.51.51,0,0,1-.45-.27L243,38.14a.5.5,0,0,1,.9-.44l3,6.18a.5.5,0,0,1-.23.67A.42.42,0,0,1,246.47,44.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "244.95px 41.0096px"
    },
    id: "eld5aqffop9hg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmn3zvnoo43k"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "256.81 58.59 253.81 52.5 248.68 55.03 251.68 61.12 249.96 61.97 250.31 62.67 258.87 58.44 258.53 57.74 256.81 58.59",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "253.775px 57.585px"
    },
    className: "animable",
    id: "el4wgkxoa3pw3"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "257.65 63.62 252.49 53.16 250 54.38 255.16 64.84 254.32 65.26 254.68 65.97 258.83 63.92 258.48 63.2 257.65 63.62",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "254.415px 59.565px"
    },
    id: "elj43rpvi7ehh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.82,89.28a20.58,20.58,0,1,1-4.59-28.74A20.58,20.58,0,0,1,347.82,89.28Z",
    style: {
      fill: "#16A085",
      transformOrigin: "331.155px 77.205px"
    },
    id: "els4173d86kc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.13,66.69,334.28,72a.16.16,0,0,1-.26,0c-.38-.65-1.23-2.91,3.91-5.53A.16.16,0,0,1,338.13,66.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "335.934px 69.2633px"
    },
    id: "elz99a20jafqa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.65,87.79a.53.53,0,0,1-.24-.06.49.49,0,0,1-.19-.68l7.59-13.69a.87.87,0,0,0,0-.91l-.7-1a.49.49,0,0,1,.13-.69.5.5,0,0,1,.69.12l.7,1a1.87,1.87,0,0,1,.1,2l-7.6,13.7A.5.5,0,0,1,327.65,87.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "331.562px 79.2332px"
    },
    id: "elvgkkot892si",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.7,91.81a3.07,3.07,0,1,1,.48,0A2.59,2.59,0,0,1,329.7,91.81Zm0-5.06a1.83,1.83,0,0,0-.33,0,2,2,0,0,0-1.32.82,2,2,0,0,0,.45,2.83,2,2,0,0,0,2.84-.45h0a2,2,0,0,0-1.64-3.22Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "329.94px 88.7503px"
    },
    id: "el8ymstmvsrxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,67.31l-3.85,5.31a.15.15,0,0,0,.08.24c.74.17,3.16.26,4-5.44A.15.15,0,0,0,339,67.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "337.173px 70.0992px"
    },
    id: "eljlfdmkcj9cn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.67,84.18a.48.48,0,0,1-.34-.14.48.48,0,0,1,0-.7L333,71.85a1.85,1.85,0,0,1,1.89-.51l1.17.35a.49.49,0,0,1,.34.62.5.5,0,0,1-.62.33l-1.17-.35a.87.87,0,0,0-.88.24L323,84A.52.52,0,0,1,322.67,84.18Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "329.301px 77.7203px"
    },
    id: "el3odq1ic21ch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.61,85.23a3,3,0,0,1-1.77-.58,3,3,0,0,1-.68-4.24h0a3.05,3.05,0,0,1,2-1.21,3,3,0,0,1,2.25.54,3,3,0,0,1-1.3,5.45A3.88,3.88,0,0,1,320.61,85.23Zm0-5.07a1.84,1.84,0,0,0-.33,0A2,2,0,0,0,319,81h0a2,2,0,1,0,2.84-.45A2,2,0,0,0,320.62,80.16Zm-2.06.55h0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "320.642px 82.1958px"
    },
    id: "el2f2ysh5sm2b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elaq3sfq1ian"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 376.97,
    cy: 147.93,
    r: 20.58,
    style: {
      fill: "#16A085",
      transformOrigin: "376.97px 147.93px",
      transform: "rotate(-14.13deg)"
    },
    className: "animable",
    id: "elg3ct4u3fg8o"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el5hsm0n4q9tk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390,145.74l-4.41,14a3.09,3.09,0,0,1-3.85,2l-16.58-5.22a3.07,3.07,0,0,1-2-3.85l5.22-16.57a3.07,3.07,0,0,1,3.85-2l14,4.41-.8,2.56a3.07,3.07,0,0,0,2,3.85Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "376.509px 147.918px"
    },
    className: "animable",
    id: "el86ipzp1sq8x"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eltbs40f34ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.4,145.24l-4.41,14a1.41,1.41,0,0,1-1.76.92L365.66,155a1.42,1.42,0,0,1-.92-1.76L370,136.62a1.4,1.4,0,0,1,1.76-.91l14,4.41-.3,1a3.07,3.07,0,0,0,2,3.85Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "376.54px 147.933px"
    },
    className: "animable",
    id: "elbz6qp9diufw"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eliwzs46zsh8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.81,148.2a.88.88,0,1,1-.57-1.11A.89.89,0,0,1,377.81,148.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "376.972px 147.928px"
    },
    className: "animable",
    id: "eliq39x5fza8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ely67oytju8um"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.91,151.08a.88.88,0,0,1-1.11.58.9.9,0,0,1-.58-1.11.89.89,0,0,1,1.69.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "376.056px 150.856px"
    },
    className: "animable",
    id: "elsiuw7ijodss"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ell6540shiqje"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.72,145.32a.88.88,0,1,1-.57-1.11A.88.88,0,0,1,378.72,145.32Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "377.883px 145.049px"
    },
    className: "animable",
    id: "elk5ekambfk6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "els2u83l3039e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.7,149.11a.88.88,0,0,1-1.11.57.88.88,0,0,1,.53-1.68A.89.89,0,0,1,380.7,149.11Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "379.857px 148.841px"
    },
    className: "animable",
    id: "el3maobvv6esv"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0f3ujpts7tw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.79,152a.88.88,0,1,1-1.68-.53.88.88,0,0,1,1.68.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "378.95px 151.735px"
    },
    className: "animable",
    id: "el8alvm8ooq1v"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elffuc80unbsp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.61,146.22a.88.88,0,0,1-1.11.58.9.9,0,0,1-.58-1.11.89.89,0,0,1,1.69.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "380.756px 145.996px"
    },
    className: "animable",
    id: "elmnt6sn6zei"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elfv8fm43k6bu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.58,150a.88.88,0,0,1-1.68-.52.88.88,0,1,1,1.68.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "382.75px 149.707px"
    },
    className: "animable",
    id: "elgy9q0ylvmpr"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eloarz0wuwhcq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.67,152.9a.88.88,0,1,1-.57-1.11A.89.89,0,0,1,382.67,152.9Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "381.832px 152.628px"
    },
    className: "animable",
    id: "elh0w57i98p46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1lejvlcnb4r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.49,147.13a.88.88,0,1,1-.58-1.11A.89.89,0,0,1,384.49,147.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "383.651px 146.861px"
    },
    className: "animable",
    id: "el1pg413d99dr"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elub2sy3gdsb8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.93,147.29a.88.88,0,1,1-.58-1.11A.89.89,0,0,1,374.93,147.29Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "374.091px 147.021px"
    },
    className: "animable",
    id: "eleyjbma4frna"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eluo43bi7yyho"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374,150.18a.88.88,0,1,1-.57-1.11A.88.88,0,0,1,374,150.18Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "373.163px 149.908px"
    },
    className: "animable",
    id: "el5dfzev5vwab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eloq6hxfv53vj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.84,144.41a.88.88,0,0,1-1.11.57.88.88,0,0,1,.53-1.68A.89.89,0,0,1,375.84,144.41Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "374.998px 144.141px"
    },
    className: "animable",
    id: "elag56mi6a0nu"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elurnt1bjtnl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.05,146.38a.88.88,0,0,1-1.11.58.9.9,0,0,1-.58-1.11.89.89,0,0,1,1.69.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "371.196px 146.156px"
    },
    className: "animable",
    id: "elv4fipcuv5k"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elherbyoihoq8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.14,149.27a.88.88,0,0,1-1.11.57.88.88,0,0,1,.53-1.68A.89.89,0,0,1,371.14,149.27Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "370.297px 149.001px"
    },
    className: "animable",
    id: "el6vj55lfes4f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elo8xztg3brkp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373,143.5a.88.88,0,1,1-.57-1.11A.89.89,0,0,1,373,143.5Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "372.162px 143.229px"
    },
    className: "animable",
    id: "elbros2d5kalv"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.23,138.52l-.81,2.56a3.09,3.09,0,0,0,2,3.85l2.56.81Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "387.631px 142.13px"
    },
    id: "elb8mhyy617i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eliwp4ob88m9m"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 172.99,
    cy: 85.31,
    r: 20.58,
    style: {
      fill: "#16A085",
      transformOrigin: "172.99px 85.31px",
      transform: "rotate(-22.5deg)"
    },
    className: "animable",
    id: "elhtvta6hd62v"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elfganvro0keo"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "173px 85.31px"
    },
    className: "animable",
    id: "el21bbzrte8gl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173,71.62a13.69,13.69,0,1,0,13.69,13.69A13.68,13.68,0,0,0,173,71.62Zm0,24.1A10.42,10.42,0,1,1,183.4,85.31,10.41,10.41,0,0,1,173,95.72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "173px 85.31px"
    },
    id: "el7sepnjixav3",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el1zcn5u6getv"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "173px 85.34px"
    },
    className: "animable",
    id: "elnlvi1yw1ejf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173,74a11.34,11.34,0,1,0,11.34,11.34A11.34,11.34,0,0,0,173,74Zm0,21.75A10.42,10.42,0,1,1,183.4,85.31,10.41,10.41,0,0,1,173,95.72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "173px 85.34px"
    },
    id: "el1j4z1cdf2dt",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elvrakri79bf"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 366.6,
    cy: 231.56,
    r: 20.58,
    style: {
      fill: "#16A085",
      transformOrigin: "366.6px 231.56px",
      transform: "rotate(-80.59deg)"
    },
    className: "animable",
    id: "elcm3f493boj"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elfxhilokq48q"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 353.74,
    y: 225.82,
    width: 25.72,
    height: 11.5,
    rx: 1.58,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "366.6px 231.57px",
      transform: "rotate(54.41deg)"
    },
    className: "animable",
    id: "el5oz641gde3l"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.68,231.29a1.57,1.57,0,1,1,.36-2.19A1.58,1.58,0,0,1,369.68,231.29Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "368.762px 230.015px"
    },
    id: "elbcld7ax9kt9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.35,234.39a1.57,1.57,0,1,1,.36-2.19A1.56,1.56,0,0,1,365.35,234.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "364.436px 233.115px"
    },
    id: "elpvca324gp7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.39,235.08a1.57,1.57,0,1,1,.36-2.19A1.57,1.57,0,0,1,372.39,235.08Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "371.474px 233.805px"
    },
    id: "el8u1fuw34z6b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.06,238.17a1.56,1.56,0,1,1,.36-2.18A1.56,1.56,0,0,1,368.06,238.17Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "367.153px 236.901px"
    },
    id: "elzswaoofjnpj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.1,238.86a1.57,1.57,0,1,1,.36-2.18A1.58,1.58,0,0,1,375.1,238.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "374.177px 237.588px"
    },
    id: "elt2pq4ps053h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.77,242a1.57,1.57,0,1,1,.36-2.19A1.57,1.57,0,0,1,370.77,242Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "369.854px 240.725px"
    },
    id: "el403uoh1kcgp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,227.5a1.56,1.56,0,1,1,.36-2.18A1.57,1.57,0,0,1,367,227.5Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "366.091px 226.231px"
    },
    id: "el5hf7khc9uud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.64,230.6a1.57,1.57,0,1,1,.36-2.18A1.55,1.55,0,0,1,362.64,230.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "361.723px 229.328px"
    },
    id: "el7s5qxex0xba",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.26,223.72a1.57,1.57,0,1,1,.36-2.19A1.58,1.58,0,0,1,364.26,223.72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "363.342px 222.445px"
    },
    id: "el60r42wkwbb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.93,226.81a1.56,1.56,0,1,1,.36-2.18A1.55,1.55,0,0,1,359.93,226.81Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "359.025px 225.541px"
    },
    id: "el3av65p0lbck",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.62,258.33a20.58,20.58,0,1,1,2.73-29A20.58,20.58,0,0,1,166.62,258.33Z",
    style: {
      fill: "#16A085",
      transformOrigin: "153.509px 242.467px"
    },
    id: "el5ofznpwt9y2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ely6lay7o9xi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.07,251.94h0a1.23,1.23,0,0,1,.16-1.72l21-17.36a1.22,1.22,0,0,1,1.72.16h0a1.22,1.22,0,0,1-.16,1.72l-21,17.36A1.22,1.22,0,0,1,142.07,251.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "153.512px 242.48px"
    },
    className: "animable",
    id: "elz5xlykj4g7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1db5n4iqvv9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.49,235.87h0a.82.82,0,0,1,.11-1.16l1.64-1.36a.83.83,0,0,1,1.16.11h0a.84.84,0,0,1-.11,1.16L162.64,236A.81.81,0,0,1,161.49,235.87Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "162.941px 234.673px"
    },
    className: "animable",
    id: "el5ldq5n3rpsr"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0xfigpa0f0ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.87,249.75h0a.28.28,0,0,1,0-.39l11.73-9.71a.28.28,0,0,1,.39,0h0a.28.28,0,0,1,0,.39l-11.73,9.71A.28.28,0,0,1,143.87,249.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "149.93px 244.7px"
    },
    className: "animable",
    id: "elw4jcl72r6i"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elvxgfs04wi9p"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 134.64,
    cy: 160.35,
    r: 20.58,
    style: {
      fill: "#16A085",
      transformOrigin: "134.64px 160.35px",
      transform: "rotate(-86.46deg)"
    },
    className: "animable",
    id: "elx0iu4p7cid"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3tqn4y7rfa4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.21,
    y: 149.63,
    width: 26.88,
    height: 21.44,
    rx: 2.1,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "134.65px 160.35px",
      transform: "rotate(-11.49deg)"
    },
    className: "animable",
    id: "elibq71wcoxs"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.36,157.56l2.83,13.91a2.11,2.11,0,0,0,2.48,1.64l22.22-4.52a2.1,2.1,0,0,0,1.64-2.47l-2.83-13.91Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "134.965px 162.681px"
    },
    id: "el2lwjg168jul",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9o36gykrzb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.66,
    y: 156.54,
    width: 3.35,
    height: 2.75,
    style: {
      fill: "#16A085",
      opacity: 0.2,
      transformOrigin: "137.335px 157.915px",
      transform: "rotate(-11.49deg)"
    },
    className: "animable",
    id: "ela07nyy394qn"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el468ggmofee"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.48,
    y: 160.58,
    width: 3.35,
    height: 2.75,
    style: {
      fill: "#16A085",
      opacity: 0.2,
      transformOrigin: "138.155px 161.955px",
      transform: "rotate(-11.49deg)"
    },
    className: "animable",
    id: "elatlje71qmsq"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elyjg7x71gxtf"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.78,
    y: 155.3,
    width: 3.35,
    height: 2.75,
    style: {
      fill: "#16A085",
      opacity: 0.2,
      transformOrigin: "143.455px 156.675px",
      transform: "rotate(-11.49deg)"
    },
    className: "animable",
    id: "elx2pmo8e2df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el81kemq8xfed"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.6,
    y: 159.34,
    width: 3.35,
    height: 2.75,
    style: {
      fill: "#16A085",
      opacity: 0.2,
      transformOrigin: "144.275px 160.715px",
      transform: "rotate(-11.49deg)"
    },
    className: "animable",
    id: "elbbdqoaq0orm"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eln5hqf5retdt"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.54,
    y: 157.78,
    width: 3.35,
    height: 2.75,
    style: {
      fill: "#16A085",
      opacity: 0.2,
      transformOrigin: "131.215px 159.155px",
      transform: "rotate(-11.49deg)"
    },
    className: "animable",
    id: "elnnjmjjpproa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elpiz34expxo"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.36,
    y: 161.83,
    width: 3.35,
    height: 2.75,
    style: {
      fill: "#16A085",
      opacity: 0.2,
      transformOrigin: "132.035px 163.205px",
      transform: "rotate(-11.49deg)"
    },
    className: "animable",
    id: "elo3d5x1o70vd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elt47u6lf61n"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.42,
    y: 159.03,
    width: 3.35,
    height: 2.75,
    style: {
      fill: "#16A085",
      opacity: 0.2,
      transformOrigin: "125.095px 160.405px",
      transform: "rotate(-11.49deg)"
    },
    className: "animable",
    id: "elexgcakxicz"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eltqa2shi7jrf"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.24,
    y: 163.07,
    width: 3.35,
    height: 2.75,
    style: {
      fill: "#16A085",
      opacity: 0.2,
      transformOrigin: "125.915px 164.445px",
      transform: "rotate(-11.49deg)"
    },
    className: "animable",
    id: "el99j2mp34qov"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elop3ryxkuqt"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.3,
    y: 164.62,
    width: 3.35,
    height: 2.75,
    style: {
      fill: "#16A085",
      opacity: 0.2,
      transformOrigin: "138.975px 165.995px",
      transform: "rotate(-11.49deg)"
    },
    className: "animable",
    id: "elqxafcr9rhsa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elqns235v618q"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.43,
    y: 163.38,
    width: 3.35,
    height: 2.75,
    style: {
      fill: "#16A085",
      opacity: 0.2,
      transformOrigin: "145.105px 164.755px",
      transform: "rotate(-11.49deg)"
    },
    className: "animable",
    id: "elmixt1oht7k8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elkf4juvd95nn"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.18,
    y: 165.87,
    width: 3.35,
    height: 2.75,
    style: {
      fill: "#16A085",
      opacity: 0.2,
      transformOrigin: "132.855px 167.245px",
      transform: "rotate(-11.49deg)"
    },
    className: "animable",
    id: "elqfl0a9tlqe8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6temc86gp92"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.06,
    y: 167.11,
    width: 3.35,
    height: 2.75,
    style: {
      fill: "#16A085",
      opacity: 0.2,
      transformOrigin: "126.735px 168.485px",
      transform: "rotate(-11.49deg)"
    },
    className: "animable",
    id: "eltt9lsbw0lrc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-69",
    className: "animable",
    style: {
      transformOrigin: "255.133px 269.558px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.93,126.21c13.24-.74,21,12.21,13.32,20.45s-2.22,12.29.87,13.79c-3.38,9.74-30.44,11.08-36.18,2.86-4.82-6.9,14-15.78,9.46-23.31S280.63,126,290.93,126.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "287.717px 147.443px"
    },
    id: "el2fho0wpmwc7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.9,184.63l1.86,2.09a3.25,3.25,0,0,0,2.78,1.08l4.89-.52a6.09,6.09,0,0,0,4.66-3.07l.59-1.06c-2.84-3.68-8.63-5.57-8.63-5.57l-1.59-.72a2.71,2.71,0,0,0-3.64,1.27l-1.47,3.13A3.12,3.12,0,0,0,210.9,184.63Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "217.881px 182.201px"
    },
    id: "elxkb1s18yygd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.44,184.15c-1.07,1.2-2,2.24-3.07,3.33s-2.05,2.12-3.09,3.17c-2.09,2.09-4.2,4.16-6.4,6.16a93.73,93.73,0,0,1-14.55,11.25l-.05,0a4,4,0,0,1-.4.22,10.14,10.14,0,0,1-4.68,1,12.36,12.36,0,0,1-3.57-.69,19.49,19.49,0,0,1-4.67-2.43,45,45,0,0,1-6.35-5.51c-1.86-1.88-3.57-3.8-5.2-5.76s-3.19-3.87-4.79-6l9.9-7.05c1.24,1.74,2.69,3.65,4.12,5.38s3,3.43,4.51,5a33.12,33.12,0,0,0,4.64,3.9,7.79,7.79,0,0,0,1.74.9c.15.05.18,0,0,0a2.37,2.37,0,0,0-1.17.26l-.45.24a62.3,62.3,0,0,0,6.12-4.6c2-1.7,4-3.55,5.89-5.47s3.79-3.91,5.61-5.95c.9-1,1.8-2.06,2.68-3.11s1.77-2.13,2.53-3.1Z",
    style: {
      fill: "#16A085",
      transformOrigin: "245.03px 192.287px"
    },
    id: "el9qmxa4x9e3b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elr166lhr57bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.44,184.15c-1.07,1.2-2,2.24-3.07,3.33s-2.05,2.12-3.09,3.17c-2.09,2.09-4.2,4.16-6.4,6.16a93.73,93.73,0,0,1-14.55,11.25l-.05,0a4,4,0,0,1-.4.22,10.14,10.14,0,0,1-4.68,1,12.36,12.36,0,0,1-3.57-.69,19.49,19.49,0,0,1-4.67-2.43,45,45,0,0,1-6.35-5.51c-1.86-1.88-3.57-3.8-5.2-5.76s-3.19-3.87-4.79-6l9.9-7.05c1.24,1.74,2.69,3.65,4.12,5.38s3,3.43,4.51,5a33.12,33.12,0,0,0,4.64,3.9,7.79,7.79,0,0,0,1.74.9c.15.05.18,0,0,0a2.37,2.37,0,0,0-1.17.26l-.45.24a62.3,62.3,0,0,0,6.12-4.6c2-1.7,4-3.55,5.89-5.47s3.79-3.91,5.61-5.95c.9-1,1.8-2.06,2.68-3.11s1.77-2.13,2.53-3.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "245.03px 192.287px"
    },
    className: "animable",
    id: "el16c8rquk0zih"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.14,416.23c7,0,6.46-.11,10.37-.24,3.35-.12,4.14.3,6.82.24,2.25-.05,2.22-2.2,1.6-4.67-.32-1.24-.81-2.76-1.24-4.77H304.13a10.86,10.86,0,0,1-8.35,5.32C292,412.61,294.37,416.23,297.14,416.23Z",
    style: {
      fill: "#16A085",
      transformOrigin: "305.055px 411.513px"
    },
    id: "el2fdlu6w9es4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.73,416.23c6.83,0,9.13-.45,13-.58,3.3-.12,3.81.58,7.15.58,2.21,0,2.63-2.49,1.91-4.36a28.7,28.7,0,0,1-1.91-5.08h-9.43c-1.84,3-6.57,5.2-11.77,5.57C239.93,412.63,242,416.23,244.73,416.23Z",
    style: {
      fill: "#16A085",
      transformOrigin: "254.377px 411.51px"
    },
    id: "el5bz205xoqfj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.43,230s-3.66,49.16-2.21,80.38c-1.56,29.31-3.8,96.43-3.8,96.43.16,1.5,8.05.9,9.43,0,0,0,17-48.89,12.7-96.43C296.23,260.78,294.14,230,294.14,230Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "274.815px 318.862px"
    },
    id: "elwldtxmpx36h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.24,230s14.51,55.49,20.27,82.74c6.06,28.61,14.24,75.06,12.62,94.07,1.6.95,7.33,1,10.56,0,0,0,12.47-65.26-3.26-92.81,5.5-67.79-12.47-84-12.47-84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "295.31px 318.771px"
    },
    id: "elj0k6p1rx9n9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.44,402.83a28.59,28.59,0,0,1-.47,3.91.78.78,0,0,0,.65,1c3.85.62,9.47-.28,11.25-.6a.82.82,0,0,0,.67-.67l.68-3.65a.79.79,0,0,0-.8-.94l-11.17.21A.83.83,0,0,0,303.44,402.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "309.585px 404.916px"
    },
    id: "el5pi3n91kajt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6kn9m31otkp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.44,402.83a28.59,28.59,0,0,1-.47,3.91.78.78,0,0,0,.65,1c3.85.62,9.47-.28,11.25-.6a.82.82,0,0,0,.67-.67l.68-3.65a.79.79,0,0,0-.8-.94l-11.17.21A.83.83,0,0,0,303.44,402.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "309.585px 404.916px"
    },
    className: "animable",
    id: "el2vnjgxex6oy"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.54,402.66c-.08,1-.22,2.83-.38,4.17a.81.81,0,0,0,.7.9,56,56,0,0,0,10.41-.12A.81.81,0,0,0,266,407l.87-3.65a.82.82,0,0,0-.76-1l-10.71-.42A.79.79,0,0,0,254.54,402.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "260.522px 404.921px"
    },
    id: "el8qvpbap7pdv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9hddghhq82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.54,402.66c-.08,1-.22,2.83-.38,4.17a.81.81,0,0,0,.7.9,56,56,0,0,0,10.41-.12A.81.81,0,0,0,266,407l.87-3.65a.82.82,0,0,0-.76-1l-10.71-.42A.79.79,0,0,0,254.54,402.66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "260.522px 404.921px"
    },
    className: "animable",
    id: "eltufhhbwqqr"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.31,185.79a167.31,167.31,0,0,0,.24,17.17c.29,7.46.8,14.79,1.88,27H299c-.75-10.58.48-22.62,7.22-46.41a8.76,8.76,0,0,0-7.49-11.38c-1.49-.15-3.06-.27-4.68-.35a118.08,118.08,0,0,0-17,0c-1.86.17-3.77.4-5.61.65A14.12,14.12,0,0,0,259.31,185.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "282.914px 200.737px"
    },
    id: "elvdcsqk6uc8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.81,152.65c-1.48,5.48-3.3,15.53.26,19.19,0,0-5.19-.78-16.22,6-3.19-4.58-.82-6-.82-6,6.22-1.46,6.4-6,5.66-10.26Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "284.127px 165.245px"
    },
    id: "el5m4e6zkptq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.17,176.5c2.07,1.38,3,6.74,3,6.74s13.72-5.19,13.22-11.25a35.16,35.16,0,0,1-3.19-2S281.29,174.41,279.17,176.5Z",
    style: {
      fill: "#16A085",
      transformOrigin: "287.287px 176.615px"
    },
    id: "elwcukbevr3s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.72,175.92a23.5,23.5,0,0,0-2.27,6c-5.51-4.55.9-10.07.9-10.07a4.65,4.65,0,0,1,3.28-.47A3.88,3.88,0,0,0,275.72,175.92Z",
    style: {
      fill: "#16A085",
      transformOrigin: "274.422px 176.593px"
    },
    id: "el6jr5zv6b3ax",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmlge4r9v52s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.28,156.29l-6.59,5.29a17.36,17.36,0,0,1,.3,3c2.36-.34,5.76-2.9,6.19-5.34A8.29,8.29,0,0,0,288.28,156.29Z",
    style: {
      opacity: 0.2,
      transformOrigin: "285.029px 160.435px"
    },
    className: "animable",
    id: "elibwuv4qws1s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.49,141.65c-1.66,8.85-2.18,12.62-7.23,16.87-7.6,6.39-18,3-19-6-.89-8.12,2-21.24,11.1-24.16A11.53,11.53,0,0,1,297.49,141.65Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "284.427px 144.755px"
    },
    id: "eljcucln6nkno",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.09,130.15c-2.69,7.16,3.07,11.42,4.35,17.61C302.11,143.33,302.58,124.81,291.09,130.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "295.268px 138.476px"
    },
    id: "elwdn4m4jifwa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.44,142.12a1.58,1.58,0,0,1-.71-.17A1.53,1.53,0,0,1,291,141a1.57,1.57,0,0,1,.09-1.2,1.59,1.59,0,0,1,.91-.78l4.68-1.52a1.57,1.57,0,1,1,1,3h0L292.92,142A1.61,1.61,0,0,1,292.44,142.12Zm4.68-4.16a1,1,0,0,0-.33.06l-4.68,1.52a1.07,1.07,0,0,0-.69,1.34,1.08,1.08,0,0,0,.53.62,1.07,1.07,0,0,0,.82.07l4.68-1.53a1.06,1.06,0,0,0,.68-1.34,1,1,0,0,0-.53-.62A1,1,0,0,0,297.12,138Zm.41,2.32Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "294.842px 139.769px"
    },
    id: "eljbenvkf141",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.47,143.12c-.11.75-.58,1.33-1.06,1.29s-.78-.67-.68-1.42.59-1.33,1.07-1.29S283.58,142.37,283.47,143.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "282.602px 143.055px"
    },
    id: "elttdxqvnw5g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.43,142.59c-.11.75-.59,1.33-1.07,1.29s-.78-.67-.67-1.42.58-1.33,1.06-1.29S274.53,141.84,274.43,142.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "273.558px 142.525px"
    },
    id: "el9o6ws5l1uqh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,141.22l-1.69-.64S273,142.05,274,141.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "273.155px 141.027px"
    },
    id: "elqo6ukmeqbu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.77,144a22.25,22.25,0,0,1-3.31,4.59,3,3,0,0,0,2.55.69Z",
    style: {
      fill: "rgb(237, 137, 62)",
      transformOrigin: "275.115px 146.667px"
    },
    id: "eltzw455uofo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.83,152.36a7.37,7.37,0,0,1-1.25,0,.2.2,0,0,1-.18-.24.24.24,0,0,1,.25-.2,6.28,6.28,0,0,0,5.07-2,.21.21,0,0,1,.31,0,.22.22,0,0,1,0,.31A6.66,6.66,0,0,1,279.83,152.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "281.245px 151.119px"
    },
    id: "el0qnin8l68of",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.49,149.17a6.17,6.17,0,0,1-4.21,2.7c-2.12.24-2.66-2.23-1.63-4.46.93-2,3.14-4.55,5.06-3.75S299.82,147.27,298.49,149.17Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "295.745px 147.698px"
    },
    id: "elsopyza6nd2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.39,152.23a2.16,2.16,0,1,1-2.16-2.16A2.16,2.16,0,0,1,297.39,152.23Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "295.23px 152.23px"
    },
    id: "elw1374z50y2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.26,138.77a.41.41,0,0,1-.3-.14,3.27,3.27,0,0,0-2.87-1.1.41.41,0,0,1-.49-.34.48.48,0,0,1,.38-.52,4,4,0,0,1,3.64,1.35.44.44,0,0,1-.05.62A.53.53,0,0,1,286.26,138.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "284.661px 137.697px"
    },
    id: "el8k71iivwbje",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.89,138.17a.43.43,0,0,1-.31-.08.44.44,0,0,1-.06-.62,4.66,4.66,0,0,1,3.62-1.92.4.4,0,0,1,.38.46.47.47,0,0,1-.48.42,3.73,3.73,0,0,0-2.85,1.56A.5.5,0,0,1,271.89,138.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "273.472px 136.862px"
    },
    id: "elrwr3ami091",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,141.76l-1.69-.65S282,142.58,283,141.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "282.155px 141.559px"
    },
    id: "elxlt6twnvc3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.82,170c-4.17,2.86-9.75,33.62-11.35,79.38a600,600,0,0,0,2.83,82.86s18.27-20.08,29.68-26c.22-42.7-8.87-71.87-7.82-82.65s7-40.59,2.43-46.19S295.82,170,295.82,170Z",
    style: {
      fill: "#16A085",
      transformOrigin: "300.543px 251.12px"
    },
    id: "elxr8gb8vavvp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcqn8gv5uxje"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.82,170c-4.17,2.86-9.75,33.62-11.35,79.38a600,600,0,0,0,2.83,82.86s18.27-20.08,29.68-26c.22-42.7-8.87-71.87-7.82-82.65s7-40.59,2.43-46.19S295.82,170,295.82,170Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "300.543px 251.12px"
    },
    className: "animable",
    id: "elkykmbzr9bwk"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.68,171.53c-4.86,7.21-15.61,97-5.47,160.67-8-4.44-13.79-16.7-13.79-16.7s-.79-55.42,3-85.52C257.64,194.64,253.44,170.7,274.68,171.53Z",
    style: {
      fill: "#16A085",
      transformOrigin: "265.016px 251.855px"
    },
    id: "elatjkdxa5m3s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsszz6k9v93k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.68,171.53c-4.86,7.21-15.61,97-5.47,160.67-8-4.44-13.79-16.7-13.79-16.7s-.79-55.42,3-85.52C257.64,194.64,253.44,170.7,274.68,171.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "265.016px 251.855px"
    },
    className: "animable",
    id: "elr6hn1xvis7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M289.09,230.41a162.59,162.59,0,0,1-6.83-14.78c-3.08-7.78-5.54-17-5.54-17s-23.32-.88-27.66,1.75c2.54,9.89,13.56,33.75,13.56,33.75S280.25,233.82,289.09,230.41Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "269.075px 216.309px"
    },
    id: "elku5cbu7y5wb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.12,235.68l21.2-.64c2.13-.06,3.23-1.62,2.43-3.46l-13.37-30.81a6,6,0,0,0-5.33-3.23l-21.2.64c-2.13.06-3.22,1.62-2.42,3.46l13.37,30.81A6,6,0,0,0,265.12,235.68Z",
    style: {
      fill: "#16A085",
      transformOrigin: "267.589px 216.61px"
    },
    id: "el8n1zcv46upr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,236.93a6.28,6.28,0,0,1-5.42-3.38L245.2,202.74a2.66,2.66,0,0,1,.08-2.55,3,3,0,0,1,2.57-1.26l21.19-.64a6.28,6.28,0,0,1,5.57,3.38L288,232.48a2.71,2.71,0,0,1-.08,2.56,3,3,0,0,1-2.57,1.25l-21.2.64H264Zm.13-.5v0l21.2-.64a2.55,2.55,0,0,0,2.15-1,2.19,2.19,0,0,0,0-2.09l-13.37-30.81a5.68,5.68,0,0,0-5.09-3.08l-21.2.64a2.57,2.57,0,0,0-2.16,1,2.2,2.2,0,0,0,0,2.09L259,233.35A5.71,5.71,0,0,0,264.12,236.43Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "266.598px 217.61px"
    },
    id: "el30hyjjmd0rj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.56,212.63l2.51-1.23a3.28,3.28,0,0,1,3,.06l4.32,2.35a6,6,0,0,1,3.13,4.61l.15,1.21c-4,2.32-10.1,1.86-10.1,1.86l-1.75.06a2.71,2.71,0,0,1-2.88-2.57l-.16-3.45A3.1,3.1,0,0,1,276.56,212.63Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "282.224px 216.311px"
    },
    id: "el4zslmb6gopf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ele4cm44lq63k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.77,189.09c-.84,13.74-.89,26.32,2.78,28.44C310.85,213.3,310.54,207.38,303.77,189.09Z",
    style: {
      fill: "#16A085",
      opacity: 0.2,
      transformOrigin: "306.347px 203.31px"
    },
    className: "animable",
    id: "elwl7duitvyb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313,179.39c.54,1.54,1,2.91,1.41,4.36s.86,2.86,1.26,4.3c.8,2.88,1.57,5.77,2.22,8.71a85.09,85.09,0,0,1,2.38,18.55,3.39,3.39,0,0,1,0,.45v.06a9.25,9.25,0,0,1-2.16,5.12,10.78,10.78,0,0,1-3.31,2.57,18,18,0,0,1-5.25,1.66,45.7,45.7,0,0,1-8.47.5c-2.67,0-5.25-.21-7.81-.45s-5.05-.51-7.72-.91l2-12c2.16.36,4.56.69,6.84.92s4.6.35,6.82.37a33.92,33.92,0,0,0,6.15-.45,6.85,6.85,0,0,0,1.72-.53c.07,0-.08,0-.42.36a3.29,3.29,0,0,0-.76,1.79l0,.52a57.19,57.19,0,0,0-.83-7.57c-.45-2.6-1.09-5.24-1.79-7.86s-1.52-5.25-2.41-7.85c-.45-1.3-.91-2.6-1.4-3.88s-1-2.61-1.46-3.75Z",
    style: {
      fill: "#16A085",
      transformOrigin: "302.914px 202.543px"
    },
    id: "el4muvqcefoln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgez02ttzs2m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313,179.39c.54,1.54,1,2.91,1.41,4.36s.86,2.86,1.26,4.3c.8,2.88,1.57,5.77,2.22,8.71a85.09,85.09,0,0,1,2.38,18.55,3.39,3.39,0,0,1,0,.45v.06a9.25,9.25,0,0,1-2.16,5.12,10.78,10.78,0,0,1-3.31,2.57,18,18,0,0,1-5.25,1.66,45.7,45.7,0,0,1-8.47.5c-2.67,0-5.25-.21-7.81-.45s-5.05-.51-7.72-.91l2-12c2.16.36,4.56.69,6.84.92s4.6.35,6.82.37a33.92,33.92,0,0,0,6.15-.45,6.85,6.85,0,0,0,1.72-.53c.07,0-.08,0-.42.36a3.29,3.29,0,0,0-.76,1.79l0,.52a57.19,57.19,0,0,0-.83-7.57c-.45-2.6-1.09-5.24-1.79-7.86s-1.52-5.25-2.41-7.85c-.45-1.3-.91-2.6-1.4-3.88s-1-2.61-1.46-3.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "302.914px 202.543px"
    },
    className: "animable",
    id: "eln5aaxua0q4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M293.79,132.71c-4.51,4.51-24.74-2.8-23.94,4.7-3.12-7,1.79-14.53,14.26-14.53C299.37,122.88,296.53,130,293.79,132.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "282.45px 130.145px"
    },
    id: "el2s66oh3ebf2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.72,155.76l-1-.3a23.8,23.8,0,0,0,1.12-6.38l1,0A25.35,25.35,0,0,1,239.72,155.76Z",
    style: {
      fill: "#16A085",
      transformOrigin: "239.78px 152.42px"
    },
    id: "el0y803lnwva3q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.36,143a24.26,24.26,0,0,0-10.6-15.42l.55-.84a25.26,25.26,0,0,1,11,16.05Z",
    style: {
      fill: "#16A085",
      transformOrigin: "234.535px 134.87px"
    },
    id: "el8kmlyob2itq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.42,173.54a25.45,25.45,0,0,1-21.32-39.32l.83.54a24.46,24.46,0,0,0,20.49,37.78Z",
    style: {
      fill: "#16A085",
      transformOrigin: "202.704px 153.88px"
    },
    id: "el27xnvvpqr6e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljfhz0t5dreb"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 215.44,
    cy: 148.09,
    r: 22.1,
    style: {
      fill: "#16A085",
      transformOrigin: "215.44px 148.09px",
      transform: "rotate(-1.52deg)"
    },
    className: "animable",
    id: "elwao8n508qvq"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elnb5ffom848e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.42,161.51l-.29-.19c2.58-6.93,8.81-11.49,12.5-17.7,1.19-2,.39-4.73-1.34-6.27l.18-.38a.77.77,0,0,0-.36-1h0a.77.77,0,0,0-1,.37l-.1.2c-1.91-.76-3.91.17-5.07,2.09-3.69,6.21-9.92,10.77-12.5,17.7h0a.74.74,0,0,0-1,.22.73.73,0,0,0,.22,1l8,5.21a.74.74,0,1,0,.81-1.23Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "214.262px 149.416px"
    },
    className: "animable",
    id: "el465p5v8z5uf"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.84,151a.5.5,0,0,1-.3-.11.49.49,0,0,1-.09-.7c1-1.23,2-2.47,3-3.67a.5.5,0,1,1,.75.66c-1,1.18-2.06,2.41-3,3.63A.53.53,0,0,1,209.84,151Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "211.341px 148.667px"
    },
    id: "ely4rmaop0lq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.08,157.43a.33.33,0,0,1-.17,0,.49.49,0,0,1-.3-.64,21.28,21.28,0,0,1,2.06-4.06.5.5,0,0,1,.85.54,20.21,20.21,0,0,0-2,3.87A.52.52,0,0,1,206.08,157.43Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "207.088px 154.969px"
    },
    id: "elpo5f8eyqzoj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.88,150a.51.51,0,0,1-.32-.12.49.49,0,0,1-.06-.7c.7-.81,1.36-1.59,2-2.37a.49.49,0,0,1,.7-.07.5.5,0,0,1,.07.7c-.65.79-1.32,1.58-2,2.38A.5.5,0,0,1,217.88,150Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "218.881px 148.312px"
    },
    id: "elfxw0b81gvr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.69,145.34a.52.52,0,0,1-.29-.09.51.51,0,0,1-.11-.7c.52-.73,1-1.42,1.39-2.11a3,3,0,0,0-.9-3.39.5.5,0,1,1,.66-.74,3.93,3.93,0,0,1,1.1,4.65c-.43.71-.9,1.42-1.44,2.18A.51.51,0,0,1,221.69,145.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "222.54px 141.738px"
    },
    id: "elezqrw6tkzqe",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-69",
    className: "animable",
    style: {
      transformOrigin: "174.915px 342.61px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.94,296.82c.61,5.19,13.59,3.73,22-3.81-5.23,2.61-16.3.83-21,2.22,1.26-2,2.51-3.93,3.73-5.73,1.26,3.55,10.9,1.77,17-4.29-3.75,2.13-11.72,1.44-15.66,2.42,2-2.9,3.94-5.48,5.66-7.69,2.77,1.18,9.32-2.59,12.59-8.54-3.06,3.14-11.71,4.51-13.85,6.76a2.52,2.52,0,0,0,.38,1c-.83,1.06-1.7,2.21-2.61,3.43-.67-3.27-5.8-9.46-6.07-13.61-1.58,7.63,2,15.88,5.32,14.64-1.49,2.05-3.07,4.29-4.68,6.73-1.21-3.63-7.43-9.94-8.14-14.5-1,8.49,3.61,17.16,7.17,16-1.3,2-2.61,4.1-3.92,6.3-2-4.33-11.23-11.24-13-16.91.32,10.78,7.58,20.76,11.86,18.85q-2,3.39-3.86,7.07c-2.71-4.69-13.63-11.61-16.1-17.83,1.32,12,10.25,22.52,14.92,20.18-1.4,2.83-2.74,5.76-4,8.79-3.36-4.37-16.76-9.33-20.75-15.41,3.95,12.24,15.58,21.27,19.83,17.64a127.89,127.89,0,0,0-4.2,12.44c-4.14-4-18.72-7.13-23.75-12.81,5.87,12,19.12,19.57,23.06,15.34A109.27,109.27,0,0,0,182.52,347c-5.41-3.63-22.29-4.16-29-9.47,8.84,12,24.79,17.77,28.64,12.67a86,86,0,0,0,1.45,28.48l1.13-.26a86.46,86.46,0,0,1-.89-32.19c1.76,6.53,19.31,4.58,30.91-5.49-7.78,3.71-24.46.49-30.48,2.89a111.45,111.45,0,0,1,2.88-12.09c1.87,5.41,17,4.25,27.4-4-6.82,2.89-20.78-.33-26.53,1.21,1.27-3.91,2.7-7.7,4.26-11.34,1.34,5.47,16.11,4.68,26.36-3.16-6.51,2.63-19.66-.6-25.28.69,1.44-3.21,3-6.29,4.52-9.23.6,5.71,15.13,4.86,25-3-6.14,2.62-18.74-.22-24,1.16C200.2,301.45,201.57,299.07,202.94,296.82Z",
    style: {
      fill: "#16A085",
      transformOrigin: "190.39px 323.83px"
    },
    id: "elz31retgkvtn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elov532wuh4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.94,296.82c.61,5.19,13.59,3.73,22-3.81-5.23,2.61-16.3.83-21,2.22,1.26-2,2.51-3.93,3.73-5.73,1.26,3.55,10.9,1.77,17-4.29-3.75,2.13-11.72,1.44-15.66,2.42,2-2.9,3.94-5.48,5.66-7.69,2.77,1.18,9.32-2.59,12.59-8.54-3.06,3.14-11.71,4.51-13.85,6.76a2.52,2.52,0,0,0,.38,1c-.83,1.06-1.7,2.21-2.61,3.43-.67-3.27-5.8-9.46-6.07-13.61-1.58,7.63,2,15.88,5.32,14.64-1.49,2.05-3.07,4.29-4.68,6.73-1.21-3.63-7.43-9.94-8.14-14.5-1,8.49,3.61,17.16,7.17,16-1.3,2-2.61,4.1-3.92,6.3-2-4.33-11.23-11.24-13-16.91.32,10.78,7.58,20.76,11.86,18.85q-2,3.39-3.86,7.07c-2.71-4.69-13.63-11.61-16.1-17.83,1.32,12,10.25,22.52,14.92,20.18-1.4,2.83-2.74,5.76-4,8.79-3.36-4.37-16.76-9.33-20.75-15.41,3.95,12.24,15.58,21.27,19.83,17.64a127.89,127.89,0,0,0-4.2,12.44c-4.14-4-18.72-7.13-23.75-12.81,5.87,12,19.12,19.57,23.06,15.34A109.27,109.27,0,0,0,182.52,347c-5.41-3.63-22.29-4.16-29-9.47,8.84,12,24.79,17.77,28.64,12.67a86,86,0,0,0,1.45,28.48l1.13-.26a86.46,86.46,0,0,1-.89-32.19c1.76,6.53,19.31,4.58,30.91-5.49-7.78,3.71-24.46.49-30.48,2.89a111.45,111.45,0,0,1,2.88-12.09c1.87,5.41,17,4.25,27.4-4-6.82,2.89-20.78-.33-26.53,1.21,1.27-3.91,2.7-7.7,4.26-11.34,1.34,5.47,16.11,4.68,26.36-3.16-6.51,2.63-19.66-.6-25.28.69,1.44-3.21,3-6.29,4.52-9.23.6,5.71,15.13,4.86,25-3-6.14,2.62-18.74-.22-24,1.16C200.2,301.45,201.57,299.07,202.94,296.82Z",
    style: {
      opacity: 0.3,
      transformOrigin: "190.39px 323.83px"
    },
    className: "animable",
    id: "el1o1lk4naobt"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172,379l-1.08-.07c2.46-36.61-26.3-67-38.78-78.32l.72-.8C145.45,311.3,174.47,342,172,379Z",
    style: {
      fill: "#16A085",
      transformOrigin: "152.144px 339.405px"
    },
    id: "elgtv8nuqczcq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.52,310.23c0-2.89,4.86-9.41,4.86-13.49C149.47,304.32,146,313,142.52,310.23Z",
    style: {
      fill: "#16A085",
      transformOrigin: "145.266px 303.749px"
    },
    id: "elbqx8praodeu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.14,304.42c-.26-2.56,3.55-8.73,3.22-12.34C142.82,298.63,140.41,306.55,137.14,304.42Z",
    style: {
      fill: "#16A085",
      transformOrigin: "139.248px 298.427px"
    },
    id: "ell8xxa09fxk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.42,316c.49-3.64,7.84-11,8.59-16.09C157.26,309.81,151.25,320,147.42,316Z",
    style: {
      fill: "#16A085",
      transformOrigin: "151.799px 308.401px"
    },
    id: "elkab1z60h5eg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.56,322.79c.88-4.05,9.8-11.62,11.1-17.33C164.18,316.73,156.51,327.7,152.56,322.79Z",
    style: {
      fill: "#16A085",
      transformOrigin: "158.123px 314.727px"
    },
    id: "el6zk4jxwn2g6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.24,330.86c1.77-4,12.62-9.94,15.18-15.57C171.56,327.07,161.29,336.79,158.24,330.86Z",
    style: {
      fill: "#16A085",
      transformOrigin: "165.83px 323.971px"
    },
    id: "elrt78ynpyokm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.26,342.2c2.42-3.88,14.52-8.39,18-13.83C178.58,340.26,166.52,348.78,164.26,342.2Z",
    style: {
      fill: "#16A085",
      transformOrigin: "173.26px 336.43px"
    },
    id: "elhwj28hkltv7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.42,353.32c3.48-3.83,17.87-6.42,22.85-11.77C184.76,354.05,169.6,361.1,168.42,353.32Z",
    style: {
      fill: "#16A085",
      transformOrigin: "179.845px 349.063px"
    },
    id: "el7rv675l03no",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.78,308.06c-2.69-1.05-10.52,1.22-14.34-.23C132.79,312.47,142.11,312.25,140.78,308.06Z",
    style: {
      fill: "#16A085",
      transformOrigin: "133.674px 309.514px"
    },
    id: "eleew5im5srcm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.75,300.63c-2-1.57-9.29-1.58-12.18-3.76C126.83,302.41,134.84,304.54,134.75,300.63Z",
    style: {
      fill: "#16A085",
      transformOrigin: "128.66px 299.749px"
    },
    id: "elmf6sngv9wj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.43,313.56c-3.49-1.16-13.29,2.26-18.24.68C135.57,319.71,147.4,318.79,145.43,313.56Z",
    style: {
      fill: "#16A085",
      transformOrigin: "136.419px 315.625px"
    },
    id: "el5mp4uphbzwn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.63,320c-4-1.07-14.81,3.43-20.48,2C139.94,327.54,153.2,325.71,150.63,320Z",
    style: {
      fill: "#16A085",
      transformOrigin: "140.552px 322.586px"
    },
    id: "elapzutfmss56",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.66,328.29c-4.26-1-15.58,3.95-21.6,2.54C145.53,336.53,159.5,334.32,156.66,328.29Z",
    style: {
      fill: "#16A085",
      transformOrigin: "146.047px 331.145px"
    },
    id: "elnvi8ixs7ghm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.7,338.9c-4.43-1.16-16.33,3.85-22.6,2.28C150.94,347.31,165.56,345.24,162.7,338.9Z",
    style: {
      fill: "#16A085",
      transformOrigin: "151.582px 341.79px"
    },
    id: "el4cr0x8cecz3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.28,350.56c-4.94-1.53-18.66,3.52-25.66,1.43C153.56,359.47,170.2,357.88,167.28,350.56Z",
    style: {
      fill: "#16A085",
      transformOrigin: "154.619px 353.574px"
    },
    id: "eliuwdekhktip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.86,416.24h24.41a3,3,0,0,0,3-2.7L196,367.8a3,3,0,0,0-3-3.32H159.16a3,3,0,0,0-3,3.32l4.69,45.74A3,3,0,0,0,163.86,416.24Z",
    style: {
      fill: "#16A085",
      transformOrigin: "176.08px 390.36px"
    },
    id: "elaqlev254ai5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elojgag2ghwb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.86,416.24h24.41a3,3,0,0,0,3-2.7L196,367.8a3,3,0,0,0-3-3.32H159.16a3,3,0,0,0-3,3.32l4.69,45.74A3,3,0,0,0,163.86,416.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "176.08px 390.36px"
    },
    className: "animable",
    id: "elr3wf2hpl1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImg);
export default __webpack_public_path__ + "static/media/home-img.b47b05a59d05e95967087e79e1b581fb.svg";
export { ForwardRef as ReactComponent };